import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import PageHeader from "../components/PageHeader";
import MenuCard from "../components/MenuCard";
import Reveal from "../components/Reveal";
import { HERO_IMAGES } from "../data/images";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BestSellers() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/best-sellers`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="page-best-sellers">
      <PageHeader
        eyebrow="Customer favourites"
        title="The crowd"
        accent="favourites."
        subtitle="The dishes everyone returns for. Bold flavours, big portions, no filler."
        image={HERO_IMAGES[0]}
      />

      <section className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map((it, i) => (
            <Reveal key={it.id} delay={i * 0.05}>
              <MenuCard item={it} featured />
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <div className="rounded-3xl bg-yellow-brand text-black p-10 md:p-16 text-center">
            <h2 className="text-3xl md:text-5xl font-extrabold balanced">
              Skip the queue.{" "}
              <span className="font-script text-5xl md:text-7xl">Call ahead.</span>
            </h2>
            <p className="mt-3 text-black/70">Order on the phone, pick up sizzling-fresh.</p>
            <div className="mt-8 flex justify-center gap-3 flex-wrap">
              <a href="tel:0434508712" className="bg-black text-yellow-brand font-extrabold rounded-full px-7 py-3 inline-flex items-center gap-2 hover:bg-black/85 transition-colors" data-testid="bs-call">
                <Phone className="w-4 h-4" /> 0434 508 712
              </a>
              <Link to="/menu" className="bg-white/15 text-black border border-black/20 font-extrabold rounded-full px-7 py-3 inline-flex items-center gap-2 hover:bg-white/30 transition-colors">
                Full menu <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
